import React from 'react'

export default function SubHeading() {
    return (
        <svg
            height='100%'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.5 10.5H16.5V25.5H13.5V19.5H7.5V25.5H4.5V10.5H7.5V16.5H13.5V10.5ZM25.5 22.5C26.265 21.885 26.4 21.57 27.09 20.925C27.7455 20.325 28.362 19.683 28.935 19.005C29.436 18.42 29.865 17.775 30.21 17.085C30.51 16.5 30.6675 15.852 30.675 15.195C30.6824 14.533 30.5441 13.8776 30.27 13.275C30.0041 12.6978 29.6149 12.1858 29.13 11.775C28.611 11.3503 28.0152 11.0295 27.375 10.83C26.6474 10.6005 25.8878 10.4891 25.125 10.5C24.585 10.5 24.0495 10.5495 23.52 10.65C23.0055 10.74 22.503 10.887 22.02 11.085C21.5636 11.2805 21.1308 11.527 20.73 11.82C20.3 12.1351 19.8892 12.4757 19.5 12.84L21.36 14.67C21.8219 14.2685 22.3246 13.9165 22.86 13.62C23.385 13.32 23.9805 13.164 24.585 13.17C25.2675 13.125 25.944 13.329 26.49 13.74C26.955 14.157 27.2055 14.766 27.165 15.39C27.144 15.984 26.955 16.56 26.625 17.055C26.1975 17.7347 25.6943 18.3637 25.125 18.93C24.465 19.575 23.655 20.31 22.74 21.075C21.825 21.84 20.625 22.665 19.5 23.55V25.5H31.5V22.5H25.5Z'
                fill='black'
            />
        </svg>
    )
}
